
import { mapGetters } from 'vuex'

export default {
  name: 'CountrySelector',

  props: {
    id: {
      type: String,
      default: 'countrySelector'
    },
    disabled: Boolean,
    errorMessage: {
      type: Array,
      default: null,
      required: false
    },
    country: {
      type: String,
      default: '',
      required: true
    },
    label: {
      type: String,
      default: '',
      required: false
    }
  },

  computed: {
    ...mapGetters({
      countriesList: 'countriesList'
    }),

    currentItem: {
      get() {
        return this.country
      },
      set(val) {
        this.$emit('update:country', val)
      }
    }
  }
}
